// extracted by mini-css-extract-plugin
module.exports = {"ThumbnailBase":"ImageThumbnail_ThumbnailBase__3G1N2","ThumbnailPrimary":"ImageThumbnail_ThumbnailPrimary__3bDVb"};